import React from "react";
import {  InfoPage, Title, Text,  BorderBottom, Container} from "./styles";
// import Ameba from "assets/imgs/Ameba.png";
const Banner = ({ title, description}) => {
  return (
    <Container data-testid="banner-header">
      {/* <BackgroundImage img={imgBanner}></BackgroundImage> */}
      <InfoPage>
        {/* <AmebaImg src={Ameba} alt="Ameba"/> */}
        {/* as="h1": mesmo estilo de antes, mas vira o H1 da página. Cobre /shop,
            /sale e /novidades, que são as três telas que usam este banner. */}
        <Title as="h1">{title}</Title>
        <BorderBottom></BorderBottom>
        <Text>
          {description}
        </Text>
      </InfoPage>
    </Container>
  );
};

export default Banner;
